import React from 'react'

const AdminDetails = () => {
  return (
    <div>AdminDetails</div>
  )
}

export default AdminDetails